import styled from "styled-components";

export const Container = styled.div` 
    display: grid;
    gap:1rem;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr))
`